import { render, staticRenderFns } from "./formSenderInformation.vue?vue&type=template&id=4112bbef"
import script from "./formSenderInformation.vue?vue&type=script&lang=js"
export * from "./formSenderInformation.vue?vue&type=script&lang=js"
import style0 from "./formSenderInformation.vue?vue&type=style&index=0&id=4112bbef&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4112bbef')) {
      api.createRecord('4112bbef', component.options)
    } else {
      api.reload('4112bbef', component.options)
    }
    module.hot.accept("./formSenderInformation.vue?vue&type=template&id=4112bbef", function () {
      api.rerender('4112bbef', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/fiscalDocuments/mdfe/components/form/steps/formSenderInformation.vue"
export default component.exports